import React from 'react';

export const RichTextViewer = (props) => (
  <div className="r-richtext" dangerouslySetInnerHTML={{ __html: props.children }}></div>
)